const validateAndUpdateField = (fieldName, originalValue, newValue, updatedData) => {
    if(newValue != originalValue) {
        updatedData[fieldName] = newValue;
    }
}

// MAIN - Función para validar los cambios en un objeto, y regresar un objeto solamente con los campos que se cambiaron
export const validateAllFields = (originalData, editedData) => {
    let updatedData = {};

    for(let key in editedData) {
        validateAndUpdateField(key, originalData[key], editedData[key], updatedData);
    }

    return updatedData;
}